import { connect } from 'react-redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/shipments/filtering/shipments.filtering.actions';
import FilterView from '../index';
import messages from '../../messages';

const mapStateToProps = (state, ownProps) => {
  const activeFilterViewId = Global.selectShipmentsFilteringActiveFilterViewId(state);
  const displayName = <FormattedMessage {...messages.filterViewAll} />;

  return {
    activeFilterViewId,
    isActive: activeFilterViewId === ownProps.filterViewId,
    displayName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onViewClick: (filterViewId) => {
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
